import React from "react";
import { Navbar, Container } from "react-bootstrap";
import BrandLogo from "./common/BrandLogo";
import LanguageDropdown from "./LanguageDropdown";
import { useAppSelector } from "../store";
import { Link } from "react-router-dom";
import LoginRegisterButtons from "./auth/LoginRegisterButtons";

interface AppNavbarProps {
  onMobileMenuToggle?: () => void;
}

const AppNavbar: React.FC<AppNavbarProps> = ({ onMobileMenuToggle }) => {
  const { isAuthenticated } = useAppSelector((state) => state.auth);

  return (
    <Navbar
      className="app-navbar border-0 bg-white"
      role="navigation"
      aria-label="Main navigation"
    >
      <Container fluid className="px-4 h-100">
        {/* Left: Hamburger & Brand */}
        <div className="d-flex align-items-center gap-2 h-100">
          {isAuthenticated && (
            <button
              className="btn btn-link text-body p-0 d-lg-none d-flex align-items-center justify-content-center rounded-circle hover-bg-secondary transition-all"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#mainMenu"
              aria-controls="mainMenu"
              aria-label="Toggle navigation"
              onClick={onMobileMenuToggle}
              style={{ width: "44px", height: "44px" }}
            >
              <i className="bi bi-list fs-4"></i>
            </button>
          )}
          { !isAuthenticated && (
          <div className="d-flex align-items-center h-100">
            <Link
              to="/"
              className="d-flex align-items-center text-decoration-none"
            >
              <BrandLogo height={24} />
            </Link>
          </div>
          )}
        </div>

        {/* Right: Actions */}
        <div className="d-flex align-items-center h-100 gap-3">
          {!isAuthenticated && <LoginRegisterButtons />}
          <LanguageDropdown />
        </div>
      </Container>
    </Navbar>
  );
};

export default AppNavbar;
